import React from "react";
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { DaysOfWeek } from "constants/reportSubscriptions";
import FieldLabel from "./FieldLabel";

const useStyles = makeStyles()(() => ({
	row: {
		display: "flex",
		flexWrap: "wrap",
		gap: "8px",
	},
	chip: {
		minWidth: "52px",
		fontWeight: 600,
	},
}));

const DaysOfWeekToggle = ({ selectedDays = [], onToggle }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			<FieldLabel required>{t("label.days")}</FieldLabel>
			<div className={classes.row}>
				{DaysOfWeek.map((day) => {
					const selected = selectedDays.includes(day.value);
					return (
						<Chip
							key={day.value}
							label={day.short}
							clickable
							onClick={() => onToggle(day.value)}
							color={selected ? "primary" : "default"}
							variant={selected ? "filled" : "outlined"}
							className={classes.chip}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default DaysOfWeekToggle;
